/**
 * Possible states assumed in authentication
 */
export const AuthState = {
    Loading: 'loading',
    NotLoggedIn: 'notLoggedIn',
    LoggedIn: 'loggedIn',
    Error: 'error',
};
//# sourceMappingURL=AuthData.js.map